import React, { useContext } from "react";
import {
  Container,
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Avatar,
} from "@mui/material";
import { LangContext } from "../../LanguageProvider"; // Убедись, что путь верный
import PhotoAlbumIcon from "@mui/icons-material/PhotoAlbum";
import InstagramIcon from "@mui/icons-material/Instagram";

// ЗАМЕНИ ЭТИ ССЫЛКИ НА СВОИ:
const VK_ALBUM_URL = "https://vk.com/albums-194277617"; // 👈 ССЫЛКА НА КОНКРЕТНЫЙ АЛЬБОМ
const INSTAGRAM_URL = "https://www.instagram.com/rvtk_07"; // 👈 ССЫЛКА НА ИНСТАГРАМ

export default function OurAchievements() {
  const { translations, lang } = useContext(LangContext);

  return (
    <Box
      sx={{
        bgcolor: "#f4f6f8", // Gray background
        minHeight: "100vh",
        pt: 15, // Space for header (moved from Container margin)
        pb: 5,
      }}
    >
      <Container maxWidth="lg">
        {/* 1. Заголовок страницы */}
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          align="center"
          sx={{ fontWeight: "bold", color: "text.primary", mb: 3 }}>
          {translations["our_achievements"]}
        </Typography>

        {/* 2. Вступительный текст */}
        <Typography
          variant="h6"
          align="center"
          color="text.secondary"
          sx={{ maxWidth: "800px", margin: "0 auto", mb: 5 }}>
          {translations["achievements_intro"]}
        </Typography>

        {/* 3. Сетка с карточками-ссылками */}
        <Grid container spacing={4} justifyContent="center">
          {/* Карточка 1: Альбом ВК */}
          <Grid item xs={12} md={5}>
            <Card
              elevation={4}
              sx={{
                height: "100%", // Added to ensure equal height
                display: "flex", // Added to ensure content stretches
                flexDirection: "column",
                transition: "transform 0.3s, box-shadow 0.3s",
                "&:hover": { transform: "translateY(-5px)", boxShadow: 8 },
              }}>
              {/* CardActionArea делает всю карточку кликабельной ссылкой */}
              <CardActionArea
                component="a" // Рендерим как тег <a>
                href={VK_ALBUM_URL}
                target="_blank" // Открывать в новой вкладке
                rel="noopener noreferrer" // Для безопасности
              >
                <CardContent sx={{ textAlign: "center", p: 4 }}>
                  <Avatar
                    sx={{
                      bgcolor: "primary.main",
                      width: 60,
                      height: 60,
                      margin: "0 auto 16px",
                    }}>
                    <PhotoAlbumIcon fontSize="large" />
                  </Avatar>
                  <Typography
                    variant="h5"
                    component="div"
                    gutterBottom
                    sx={{ color: "text.primary" }}>
                    {translations["vk_albums_title"]}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {translations["vk_albums_desc"]}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>

          {/* Карточка 2: Instagram */}
          <Grid item xs={12} md={5}>
            <Card
              elevation={4}
              sx={{
                height: "100%", // Added to ensure equal height
                display: "flex", // Added to ensure content stretches
                flexDirection: "column",
                transition: "transform 0.3s, box-shadow 0.3s",
                "&:hover": { transform: "translateY(-5px)", boxShadow: 8 },
              }}>
              <CardActionArea
                component="a"
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer">
                <CardContent sx={{ textAlign: "center", p: 4 }}>
                  <Avatar
                    sx={{
                      background:
                        "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
                      width: 60,
                      height: 60,
                      margin: "0 auto 16px",
                    }}>
                    <InstagramIcon fontSize="large" />
                  </Avatar>
                  <Typography
                    variant="h5"
                    component="div"
                    gutterBottom
                    sx={{ color: "text.primary" }}>
                    {translations["insta_page_title"]}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {translations["insta_page_desc"]}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
